import { Ref } from "@vue/reactivity"
import { onMounted } from "@vue/runtime-core"

export const useElementOverflow = (el: Ref<HTMLElement | null>) => {
  const hasOverflow = ref(false)
  const toBottom = ref(false)

  const isOverflowing = computed(() => hasOverflow.value && !toBottom.value)

  const checkOverflow = () =>
    (hasOverflow.value =
      (el?.value?.scrollHeight ?? 0) > (el?.value?.offsetHeight ?? 0)) || false

  const checkScrollPosition = () => {
    const scrollTop = el?.value?.scrollTop ?? 0
    const scrollHeight = el?.value?.scrollHeight ?? 0
    const height = el?.value?.offsetHeight ?? 0
    toBottom.value = Math.round(scrollTop + height) >= scrollHeight
  }

  const refresh = () => {
    checkOverflow()
    checkScrollPosition()
  }

  const debouncedScrollPosition = useDebounceFn(checkScrollPosition, 250)
  const debouncedCheckOverflow = useDebounceFn(checkOverflow, 100)

  onMounted(() => {
    refresh()
    el?.value?.addEventListener("scroll", debouncedScrollPosition)
    window.addEventListener("resize", debouncedScrollPosition)
    window.addEventListener("resize", debouncedCheckOverflow)
  })

  onBeforeUnmount(() => {
    el?.value?.removeEventListener("scroll", debouncedScrollPosition)
    window.removeEventListener("resize", debouncedScrollPosition)
    window.removeEventListener("resize", debouncedCheckOverflow)
  })

  return { hasOverflow, isOverflowing, refresh }
}
